import React, { Component } from 'react';
import Progress from 'react-progress';
import PropTypes from 'prop-types';

const DEFAULT_TIMEOUT = 20000;
const DEFAULT_SPEED = 0.4;
const HIDE_DELAY = 0.4;
const REFRESH_INTERVAL = 100;

class LoadingBar extends Component {
  // js implementation of css easeInOutQuad (https://gist.github.com/gre/1650294)
  static easeOutQuart(t) {
    const tMinus1 = t - 1;
    return 1 - tMinus1 * tMinus1 * tMinus1 * tMinus1;
  }

  static calculateBarPercentage(ms, loadingTimeout) {
    return LoadingBar.easeOutQuart(ms / loadingTimeout) * 100;
  }

  constructor(props) {
    super();
    this.state = { progress: 0, speed: DEFAULT_SPEED };
    this.loadingTimeout = props.loadingTimeout;
    this.currentTime = 0;
    this.refresher = null;
    this.stopper = null;
    this.clearRefresher();
  }

  componentDidMount() {
    if (this.props.isLoading === true) {
      this.start();
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.isLoading === this.props.isLoading) {
      return;
    }

    if (props.isLoading === true) {
      this.start();
    } else {
      this.stop();
    }
  }

  componentWillUnmount() {
    this.clearRefresher();
    this.clearStopper();
  }

  start() {
    this.clearRefresher();
    this.currentTime = 0;
    this.refresher = setInterval(() => {
      this.refresh();
    }, REFRESH_INTERVAL);
  }

  refresh() {
    if (this.props.isLoading && this.currentTime < this.loadingTimeout) {
      this.incrementBar();
    } else {
      this.stop();
    }
  }

  incrementBar() {
    this.currentTime += REFRESH_INTERVAL;
    this.setState({
      progress: LoadingBar.calculateBarPercentage(
        this.currentTime,
        this.loadingTimeout,
      ),
      speed: DEFAULT_SPEED,
    });
  }

  stop() {
    this.clearRefresher();
    this.setState({ progress: 100 });
    this.stopper = setTimeout(
      () => this.setState({ progress: 0, speed: 0 }),
      (HIDE_DELAY + 0.1) * 1000,
    );
  }

  clearRefresher() {
    clearInterval(this.refresher || null);
    this.refresher = null;
  }

  clearStopper() {
    clearTimeout(this.stopper || null);
    this.stopper = null;
  }

  render() {
    return (
      <Progress
        percent={this.state.progress}
        className="LoadingBar"
        color="#80BE00"
        height="5"
        speed={this.state.speed}
        hideDelay={HIDE_DELAY}
      />
    );
  }
}

LoadingBar.propTypes = {
  isLoading: PropTypes.bool,
  loadingTimeout: PropTypes.number,
};

LoadingBar.defaultProps = {
  isLoading: true,
  loadingTimeout: DEFAULT_TIMEOUT,
};

export default LoadingBar;
